import store from '@/store'
import axios from 'axios'
import { Message } from 'element-ui'

// 模块路径前缀映射表
const portMap = { "base": "daocui-base/", "health": "daocui-health/", "clinic": "daocui-clinic/", "pharmacy": "daocui-pharmacy/", "vend": "daocui-vend/", "gateway": "daocui-gateway/", "wechat": "daocui-wechat/" }

// 地址配置
/**
 * 地址配置 dev : 192.168.31.120 pro: 43.143.243.229
 * @type {{dev: string, pro: string}}
 */
const url_config = {
  dev: "192.168.31.120:8089/mall-gateway",
  // dev: "47.117.173.218",
  // dev: "192.168.31.22",
  // dev: "123.56.122.240",
  // dev: "43.143.243.229",
  // pro: "43.143.243.229"
  // pro: "123.56.122.240",
  pro: "/webapi"
}

const env = process.env.NODE_ENV
const baseURL = env === "development" ? url_config.dev : url_config.pro

// 创建
const service = axios.create({
  // 设置 Base Url ，请求url = base url + request url 默认：process.env.VUE_APP_BASE_API
  baseURL, // 跨域请求时是否需要使用凭证，默认false
  // withCredentials: true,
  // 设置请求超出时间
  // timeout: 20000
  timeout: 100000
})

// request/请求 拦截器
service.interceptors.request.use(// 请求前拦截器
  config => {
    // 获取配置中的请求地址
    const token = store.getters['setting/getToken']
    // 对所有模块URL添加 daocui- 前缀（已含前缀则跳过）
    if (config.url && !config.url.startsWith('/') && !config.url.startsWith('http') && !config.url.startsWith('daocui-')) {
      const firstSlash = config.url.indexOf("/")
      if (firstSlash > 0) {
        const sysName = config.url.substring(0, firstSlash)
        if (portMap[sysName]) {
          config.url = 'daocui-' + sysName + '/' + config.url
        }
      }
    }
    if (env === "development") {
      // 开发环境：需要完整的 http://host:port/ 地址
      config.baseURL = "http://" + baseURL + "/"
    } else {
      // 生产环境：baseURL 是相对路径 /webapi，直接拼接即可
      config.baseURL = baseURL + "/"
    }
    // 设置Token到请求列表
    config.headers['Authorization'] = token === undefined ? "Visitor" : token
    return config
  }, // 异常处理器
  error => {
    // 输出异常信息
    return Promise.reject(error)
  })

// response/响应 拦截器
service.interceptors.response.use(// 预处理 response
  response => {
    // 输出响应内容
    const status = response.status
    const reData = response.data
    const reCode = reData.code

    // 处理请求异常
    if (status !== 200) {
      Message({
        message: '请求失败，异常码：' + status, type: 'error', duration: 12 * 1000
      })
      return Promise.reject(new Error('Error'))
    }

    // 处理系统异常
    if (reCode !== 1) {
      const message = reData.message
      Message({
        message: message, type: 'error', duration: 5 * 1000
      })
      return Promise.reject(message)
    }
    return reData
  },

  // 异常处理器
  error => {
    // 输出异常信息
    Message({
      message: error.message, type: 'error', duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service
